module.exports = __webpack_public_path__ + "img/flies.d2450d69.svg";